import {
    UserId,
    ControlResultUserPoolOverview,
    ExistingControlResultPaginatedListDto as ControlResultPaginatedListDto,
    UserOverview,
    ControlOverview,
    ControlProgramOverview,
    ControlProgramId,
} from "api/generated/model";
import { buildClassNamesById } from "org/controlActivities/list/utils/classification";
import { IdMap } from "utils/idMap";

/**
 * Context for looking up linked resources in the control results overview.
 */
export interface LookupContext {
    controlProgramsById: IdMap<ControlProgramId, ControlProgramOverview>;
    controlsById: IdMap<string, ControlOverview>;
    usersById: IdMap<UserId, UserOverview>;
    controlResultUserPoolsById: IdMap<string, ControlResultUserPoolOverview>;
    // Only reached from the classification report's drill-down links
    classificationClassNamesById: Map<string, string>;
}
export function buildLookupContext(
    controlResultsDto: ControlResultPaginatedListDto
): LookupContext {
    const linkedResources = controlResultsDto.linkedResources;
    const controlProgramsById = IdMap.fromArray({
        name: "controlProgramsById",
        items: linkedResources.controlPrograms,
        getId: (cpDto) => cpDto.resource.id,
        getValue: (cpDto) => cpDto.resource,
    });
    const controlsById = IdMap.fromArray({
        name: "controlsById",
        items: linkedResources.controls,
        getId: (cDto) => cDto.resource.id,
        getValue: (cDto) => cDto.resource,
    });
    const usersById = IdMap.fromArray({
        name: "usersById",
        items: linkedResources.users,
        getId: (userDto) => userDto.resource.id,
        getValue: (userDto) => userDto.resource,
    });
    const controlResultUserPoolsById = IdMap.fromArray({
        name: "controlResultUserPoolsById",
        items: linkedResources.controlResultUserPools,
        getId: (pool) => pool.id,
        getValue: (pool) => pool,
    });
    return {
        controlProgramsById,
        controlsById,
        usersById,
        controlResultUserPoolsById,
        classificationClassNamesById: buildClassNamesById(
            linkedResources.classification
        ),
    };
}
